import * as React from "react";
import { RotatingLines } from "react-loader-spinner";
import styles from "./styles.module.css";

type LoaderProps = {
  text?: string;
  fullScreen?: boolean;
};

const Loader = ({ text = "Loading", fullScreen = true }: LoaderProps) => {
  return (
    <div
      className={`${styles.loaderWrapper} ${
        fullScreen ? styles.fullScreen : ""
      }`}
      role="status"
      aria-live="polite"
      aria-label={text}
    >
      <div className={styles.loaderCard}>
        <div className={styles.brandMark}>
          <span className={styles.logoOrange}>Up</span>
          <span className={styles.logoWhite}>coma</span>
        </div>

        <div className={styles.spinnerWrap}>
          <RotatingLines
            width="44"
            strokeColor="#ff4b2b"
            strokeWidth="5"
            animationDuration="0.75"
            ariaLabel="loading"
            visible={true}
          />
        </div>

        <div className={styles.loadingText}>
          <p>{text}</p>
          <span>Preparing your admin experience...</span>
        </div>

        <div className={styles.loadingBars} aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default Loader;
